import actions from "./actions";
import mutations from "./mutation";

export default {
  namespaced: true,
  state: {
    loans: [],
    loanCaps: [],
    modelType: "branch",
    loanTypes: [],
    loanDisbursements: [],
    loanRefunds: [],
    loanRequests: [],
    loanApprovals: [],
    loanRequestsApproval: [],
    loanApprovalsCurrentPage: 1,
    loanApprovalsPerPage: 5,
    loanApprovalsTotal: null,
    loanRequestsCurrentPage: 1,
    loanRequestsPerPage: 5,
    loanRequestsTotal: null,
    loanRequestsApprovalCurrentPage: 1,
    loanRequestsApprovalPerPage: 5,
    loanRequestsApprovalTotal: null,
    loanDisbursementsCurrentPage: 1,
    loanDisbursementsPerPage: 5,
    loanDisbursementsTotal: null,
    loanRefundsCurrentPage: 1,
    loanRefundsPerPage: 5,
    loanRefundsTotal: null,
    loanCapsTotal: null,
    loanTypesTotal: null,
    tableLoading: false,
    currentPage: 1,
    perPage: 5,
    loanCapsPerPage: 5,
    loanCapsCurrentPage: 1,
    searchQuery: "",
  },
  actions,
  mutations,
};
